(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/player-timelimits/assets/javascripts/get-player-timelimits.js') >= 0) return;  svs.modules.push('/components/accountservices/player-timelimits/assets/javascripts/get-player-timelimits.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
let logger;
let jupiter;
if (svs.isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  logger = trinidad.logger('accountservices:player-timelimits');
  jupiter = trinidad.jupiter;
} else {
  logger = svs.core.log.getLogger('accountservices:player-timelimits');
  jupiter = svs.core.jupiter;
}

const fetchPlayerGameLimits = async req => {
  let data;
  try {
    const options = {
      method: 'get',
      path: '/player/1/gamelimits'
    };
    if (svs.isServer) {
      options.req = req;
    }
    data = await jupiter.callAsync(options);
    return [null, data];
  } catch (err) {
    logger.info('fetch-player-timelimits error', err);
    return [err, null];
  }
};
const getPlayerTimeLimits = async req => {
  if (svs.isServer) {
    if (!req.userSession.hasRole(req.userSession.roles.PLAYER)) {
      throw new Error('Player not logged in');
    }
  } else if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
    throw new Error('Player not logged in');
  }
  const _await$fetchPlayerGam = await fetchPlayerGameLimits(req),
    _await$fetchPlayerGam2 = _slicedToArray(_await$fetchPlayerGam, 2),
    err = _await$fetchPlayerGam2[0],
    data = _await$fetchPlayerGam2[1];
  if (data !== null && data !== void 0 && data.response) {
    var _data$response;
    return (_data$response = data.response) === null || _data$response === void 0 ? void 0 : _data$response.time;
  }
  logger.info('error while trying to fetch player game limits:', err);
  return null;
};
if (svs.isServer) {
  module.exports = {
    getPlayerTimeLimits
  };
} else {
  setGlobal('svs.accountServices.player_timelimits', {
    getPlayerTimeLimits
  });
}

 })(window);